import { FormFieldGroup, FormLabel, FormSelect, Option } from '$components'
import { Input } from './index'
import { Role } from '$api-client/types.gen'

const roleOptions: Option[] = [
  { id: Role.ADMIN, value: 'Admin' },
  { id: Role.GROOMER, value: 'Groomer' },
  { id: Role.RECEPTIONIST, value: 'Receptionist' },
]

export function EditTeamMemberDetailsContent() {
  return (
    <div className="flex flex-col gap-6 flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.Role}>
          Role
        </FormLabel>

        <FormSelect
          name={Input.Role}
          placeholder="Select role..."
          options={roleOptions}
        />
      </FormFieldGroup>
    </div>
  )
}
